import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment'; 
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-revaluation-result',
  templateUrl: './revaluation-result.component.html',
  styleUrls: ['./revaluation-result.component.scss']
})
export class RevaluationResultComponent implements OnInit {

  ResultForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  Row1 = true;
  Row2 = true;
  Row3 = true;
  afterList = false;
  readOnlyFlag = false;
  APIService: any;
  codeMarks1List: any;
  filteredCodeMarks1: any;
  submitpayload: any;
  filteredCodeType: any;
  codeTypeList: any;
  filteredDataList: any;
  statusList = [
    { value: '', label: '' },
    { value: 'A', label: 'A' },
    { value: 'U', label: 'U' }
  ];
  setRemList = [
    { value: '', label: '' },
    { value: 'S', label: 'S' },
    { value: 'R', label: 'R' }
  ]
  DataList: any;
  RGInCode = 0;
  G_Regn_Roll = '';
  TitleOne = 'titleOne';
  TitleTwo = 'TitleTwo';
  TitleThree = 'TitleThree';
  EcId: any;
  Shid: any;
  Rollno = false;
  Regno = false;
  gridList: any;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,
    private route: ActivatedRoute,
    public fb: FormBuilder) {  this.APIService = environment.serviceUrl;  }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.fetchList(this.SessionNo);
    }
    this.route.queryParams.subscribe((params) => {
      this.RGInCode = params['MenuCode'];
      this.resetValues();
      //this.loadpage(this.RGInCode);
      this.ResultForm = this.fb.group({
        EcId: new FormControl('',[Validators.required]),
        listNo2: new FormControl(''),
        listNo3: new FormControl(''),
        Valid: new FormControl(''),
        Chng: new FormControl(''),
        Batch: new FormControl(''), //removed required
        EmCode: new FormControl(''),
        ExcpCode: new FormControl(''),
        SetRem: new FormControl('',[Validators.pattern("^[a-zA-Z ]*$")]),
        Sub: new FormControl('',[Validators.required]), 
        Head: new FormControl(''), //removed required
        RegnNo: new FormControl('',[Validators.required]),
        RollNo: new FormControl(''),
        Marks: new FormControl('',[Validators.required,Validators.pattern("^[0-9 .]*$")]),
        MarksD: new FormControl(''),
        Grade: new FormControl(''),
        Status: new FormControl(''),
        Comment: new FormControl(''),
        Mesg: new FormControl(''),
       } );
       this.fetchCodeMarks1();
       this.conditions();
       this.checkDecimal();
      // this.fetchList();
    });
  }
  

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.fetchList(this.SessionNo);
      }
    );
    //this.fetchList(res.projectPharam['SnNo']);
  }

  resetValues(){
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.Rollno = false;
    this.Regno = false;
    this.Row1 = false;
    this.Row2 = false;
    this.Row3 = false;
    this.afterList = false;
    this.readOnlyFlag = false;
  }

  // loadpage(e) {
  //   if (e == 24) {
  //     this.TitleOne = 'Revaluation';
  //     this.fetchList();
  //   } else if (e == 21) {
  //     this.TitleOne = 'Change Updated Result';
  //     this.fetchList();
  //   } 
  // }

  conditions(){
   // this.G_Regn_Roll = this.umsService.secretdata['RegnRoll'];
   this.umsService.getSecretData().subscribe((res) => {
    this.G_Regn_Roll = res.projectPharam['RegnRoll'];
    if(this.G_Regn_Roll == 'G'){
      this.Rollno = false;
      this.Regno = true;
    }
    else{
      this.Rollno = true;
      this.Regno = false;
    }
    }
  );
   
  }

  fetchList(id) {
    let payload = {};
    payload['SnNo'] = id;
    payload['InCode'] = 24;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
      }
    });
  }

  list(){
      if(this.ResultForm.controls['EcId'].invalid){
        this.ResultForm.get('EcId').markAsTouched();
      }
      else{
        this.Row1 = true;
        this.Row2 = true;
        this.Row3 = true;
        this.GridData(this.EcId)
      }
      
      // this.ControlLock(this.EcId)
  }

  // icrbtn(){
  //     this.Row1 = true;
  //     this.Row2 = true;
  //     this.Row3 = true;
  // }


  getListData(id){

    this.ResultForm.controls['listNo2'].setValue(id.Oper);
    this.ResultForm.controls['listNo3'].setValue(id.EcDesc);
    
    this.EcId = id.EcId;
    this.Shid = id.InShId;
   // this.GridData(id.EcId);
    // this.checkDecimal(id);

  }

  fetchCodeMarks1() {
    const payload = {};
    payload['CdType'] = 'EX';
    payload['CdCode'] = 'WH';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.codeTypeList = res.data;
        this.filteredCodeType = this.codeTypeList.slice();
      } else {
       
      }
    });
  }

  checkDecimal(){
    let payload = {};
    payload['EmId'] = 523;
    this.umsService.checkForDecimal(payload).subscribe((res) => {
      if(res.data['EmMarksD'] == "Y"){
        this.setValidor();
      }else{
        this.removeValidator();
      }
    });
  }

  setValidor() {
    this.ResultForm.controls['Marks'].setValidators([Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]{1,2})?))$')]);
    
  }

  removeValidator() {
    this.ResultForm.controls['Marks'].clearValidators();
  }
  
  // ControlLock(id){
  //   const payload = {};
  //   payload['EcId'] = id;
  //   payload['LoginId'] = sessionStorage.getItem('userId');
  //   this.umsService.EditCtrlLock(payload).subscribe((res) => {
  //     if (res.status) {
  //       // this.subList = res.data;
  //       // this.filteredSubList = this.subList.slice();
  //     } else {
  //      this.Row1 = false;
  //      this.Row2 = false;
  //      this.Row3 = false;
  //     }
  //   });
  // }



 // ControlUnLock(id){
  //   const payload = {};
  //   payload['CMarks'] = id;
  //   payload['LoginId'] = 0;
  //   this.umsService.EditCtrlLock(payload).subscribe((res) => {
  //     if (res.status) {
  //       // this.subList = res.data;
  //       // this.filteredSubList = this.subList.slice();
  //     } else {
  //     }
  //   });
  // }

  
  GridData(EcId) {
    const payload = {};
    payload['EcId'] = EcId;
    payload['Chng'] = this.ResultForm.value['Chng'];
    payload['Valid'] = this.ResultForm.value['Valid'];
  //  this.afterList = true;
    this.umsService.SearchResult(payload).subscribe((res) => {
      if (res.status) {
        this.gridList = res.data;
        this.afterList = true;
      } else {
        this.afterList = true;
      }
    });
  }


  // deletee(e, k){
  //   if (e === 'true'){
  //     this.prepopulationForDelete(k);
  //   } else {
      
  //   }
  // }

  prepopulationForDelete(data){
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
    this.ResultForm = this.fb.group({
      EcId: new FormControl(data.EcId,[Validators.required]),
      listNo2: new FormControl(data.listNo2),
      listNo3: new FormControl(data.listNo3),
      Valid: new FormControl(data.Valid),
      Chng: new FormControl(data.Chng),
      Batch: new FormControl(data.Batch),
      EmCode: new FormControl(data.EmCode),
      ExcpCode: new FormControl(data.ExcpCode),
      SetRem: new FormControl(data.SetRem,[Validators.pattern("^[a-zA-Z ]*$")]),
      Sub: new FormControl(data.Sub,[Validators.required]),
      Head: new FormControl(data.Head),
      RegnNo: new FormControl(data.RegnNo,[Validators.required]),
      RollNo: new FormControl(data.RollNo),
      Marks: new FormControl(data.Marks,[Validators.required,Validators.pattern("^[0-9 .]*$")]),
      MarksD: new FormControl(data.MarksD),
      Grade: new FormControl(data.Grade),
      Status: new FormControl(data.Status),
      Comment: new FormControl(data.Comment),
      Mesg: new FormControl(data.Mesg),
     } );
  }
 
 

  // edit(k,id){
  //   if (k === 'true') {
  //     this.prepopulation(id);
  //   }
  // }

  editData(k){
    this.prepopulation(k);
  }

  deleteData(k){
    this.prepopulationForDelete(k);
  }


  prepopulation(data){
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.readOnlyFlag = true;
    this.ResultForm = this.fb.group({
      EcId: new FormControl(data.EcId,[Validators.required]),
      listNo2: new FormControl(data.listNo2),
      listNo3: new FormControl(data.listNo3),
      Valid: new FormControl(data.Valid),
      Chng: new FormControl(data.Chng),
      Batch: new FormControl(data.Batch), 
      EmCode: new FormControl(data.EmCode),
      ExcpCode: new FormControl(data.ExcpCode),
      SetRem: new FormControl(data.SetRem, [Validators.pattern("^[a-zA-Z ]*$")]),
      Sub: new FormControl(data.Sub,[Validators.required]),
      Head: new FormControl(data.Head),
      RegnNo: new FormControl(data.RegnNo,[Validators.required]),
      RollNo: new FormControl(data.RollNo),
      Marks: new FormControl(data.Marks,[Validators.required,Validators.pattern("^[0-9 .]*$")]),
      MarksD: new FormControl(data.MarksD),
      Grade: new FormControl(data.Grade),
      Status: new FormControl(data.Status),
      Comment: new FormControl(data.Comment),
      Mesg: new FormControl(data.Mesg),
     } );
    
  }


  // submit(){
  //   if (this.ResultForm.invalid) {
  //     this.ResultForm.get('EcId').markAsTouched();
  //     this.ResultForm.get('Sub').markAsTouched();
  //     this.ResultForm.get('Batch').markAsTouched();
  //     this.ResultForm.get('Head').markAsTouched();
  //     if(this.Regno == true){
  //       this.ResultForm.controls['RegnNo'].setValidators(Validators.required);
  //       this.ResultForm.get('RegnNo').markAsTouched();
  //     }
  //     else if(this.Regno == false){
  //       this.ResultForm.controls['RegnNo'].clearValidators();
  //       this.ResultForm.get('RegnNo').markAsUntouched();
  //     }
  //     if(this.Rollno == true){
  //       this.ResultForm.controls['RollNo'].setValidators(Validators.required);
  //       this.ResultForm.get('RollNo').markAsTouched();
  //     }
  //     else if(this.Rollno == false){
  //       this.ResultForm.controls['RollNo'].clearValidators();
  //       this.ResultForm.get('RollNo').markAsUntouched();
  //     }
  //     return;
  //   } else {
  //     this.submitRevalResult();
  //   }
  // }


  submit(){
    if(this.ResultForm.invalid) {
       this.ResultForm.get('EcId').markAsTouched();
       this.ResultForm.get('Sub').markAsTouched();
       this.ResultForm.get('RegnNo').markAsTouched();
       this.ResultForm.get('Marks').markAsTouched();
    }
    else{
       this.submitRevalResult()
    }
  }
   

  submitRevalResult() {
    this.spinner.show();
    this.submitpayload = this.ResultForm.value;
    
    //will check later for withhold cases - 11.12.24
    // if(this.submitpayload.ExcpCode != "" || this.submitpayload.ExcpCode != null){
    //   if(this.submitpayload.SetRem != 'R'){
    //     this.submitpayload.SetRem = 'S'
    //   }
    // }
    // else if(this.submitpayload.ExcpCode == "" || this.submitpayload.ExcpCode == null){
    //   this.submitpayload.SetRem = ""
    // }

    if(this.submitpayload.Sub == "" || this.submitpayload.Sub == null){
      let  data = {}
        data['message'] = "Subject Required"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }

    // updated status on 12.12.24
    // if(this.submitpayload.Status != "" || this.submitpayload.Status != null){
    //   this.submitpayload.Marks = "";
    //   //this.submitpayload.MarksD = "";
    //   this.submitpayload.Grade = "";
    // }

    // if(this.submitpayload.Status != '' || this.submitpayload.Status != null){
    //   if(this.submitpayload.Status == 'A' || this.submitpayload.Status == 'U'){
    //     this.submitpayload.Marks = 0;
    //     //this.submitpayload.MarksD = "";
    //     this.submitpayload.Grade = "";
    //   }
    //   else if(this.submitpayload.Status != "A" || this.submitpayload.Status != "U"){
    //     let  data = {}
    //       data['message'] = "Status Can Be A-Absent/U-Unfair Means"
    //       data['title'] = 'Information'
    //       data['icon'] = 'fas fa-close'
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   }
    // }
    // else{
      
    // }

    
    if(this.submitpayload.Status == 'A' || this.submitpayload.Status == 'U'){
      this.submitpayload.Marks = 0;
      //this.submitpayload.MarksD = "";
      // this.submitpayload.Grade = "";
    }
   
    // if(this.submitpayload.Grade != "" || this.submitpayload.Grade != null){
    //   this.submitpayload.Marks = "";
    //   this.submitpayload.MarksD = "";
    // }
    // else if(this.submitpayload.Grade == "" || this.submitpayload.Grade == null){
    //   this.submitpayload.Marks = 0;
    //   this.submitpayload.Marks.setValue(0);
    // }
    // if(this.submitpayload.Marks == 0){
    //   let  data = {}
    //   data['message'] = "Confirm Zero Marks"
    //   data['title'] = 'Information'
    //   data['icon'] = 'fas fa-close'
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    // }

    this.umsService.addResult(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
         window.location.reload();
         // this.ngOnInit();
         // this.GridData(this.EcId)
          });
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
       window.location.reload();
        //this.ngOnInit();
          });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
     window.location.reload();
    //  this.ngOnInit(); 
        });
    });
    
  }


  deleteRecord(){
    const  data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes'){
        this.Deletedata(this.ResultForm.value);
      }else{
        this.dialogRef.close();
      }
    });
  }

  Deletedata(id){
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),  body: {
        
        ExcpCode: id.ExcpCode,
        Head: id.Head,
        EcId: id.EcId,
        Batch: id.Batch,
        EmCode: id.EmCode,
        RollNo: id.RollNo,
        RgNo: id.RgNo,
        Sub: id.Sub,
        Marks: id.Marks,
        MarksD: id.MarksD,
        Grade: id.Grade,
        Status: id.Status,
        SetRem: id.SetRem,
        Comment: id.Comment,
        Mesg: id.Mesg,
      },
    };
      this.httpClient.delete(this.APIService + '/inputs/EditChResult', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let  data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
         window.location.reload();
        // this.ngOnInit();

        });
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          window.location.reload();
        // this.ngOnInit();
          });
        // this.umsService.openSnackbar(ERROR.error.message);
        // this.GridData(this.EcId)
     });
  }

  // update(){
  //   if (this.ResultForm.invalid) {
  //     this.ResultForm.get('EcId').markAsTouched();
  //     this.ResultForm.get('Sub').markAsTouched();
  //     this.ResultForm.get('Batch').markAsTouched();
  //     this.ResultForm.get('Head').markAsTouched();
  //     return;
  //   } else {
  //     this.updateResult();
  //   }
  // }


  update(){
    if(this.ResultForm.invalid) {
       this.ResultForm.get('EcId').markAsTouched();
       this.ResultForm.get('Sub').markAsTouched();
       this.ResultForm.get('RegnNo').markAsTouched();
       this.ResultForm.get('Marks').markAsTouched();
    }
    else{
       this.updateResult()
    }
  }

  updateResult(){
    this.spinner.show();
    this.submitpayload = this.ResultForm.value;
    if(this.submitpayload.Status == 'A' || this.submitpayload.Status == 'U'){
      this.submitpayload.Marks = 0;
      //this.submitpayload.MarksD = "";
      // this.submitpayload.Grade = "";
    }
    this.umsService.updateResult(this.submitpayload).subscribe(res => {
      if (res.status){
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
         window.location.reload();
        // this.ngOnInit();
        });
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
         window.location.reload();
        // this.ngOnInit();

        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       window.location.reload();
      //this.ngOnInit();
    });
  }

}
